import {Schema, type} from "@colyseus/schema";
import {Ingredient, IngredientTypes} from "./ingredients";
import {nanoid} from "nanoid";
import {mainLogger} from "../shared/logger";
import {GameSchema, Position} from "./game_element_schema";

const logger = mainLogger.child({label:'server.state.basket'})

type IngredientGenerator = { createNewIngredient: (x: number, y: number, type:IngredientTypes, basket:Basket) => Ingredient }


export class Basket extends GameSchema {
    @type("string") ingredientType
    state: IngredientGenerator
    currentIngredient: Ingredient;
    get printableId() {return this.id}
    get printableState(): string { return `x:${this.x},y:${this.y}` }
    toString(): string {
        return `${this.printableId}(${(this.printableState)})`
    }

    constructor(x:number, y:number, ingredientType: IngredientTypes, generator: IngredientGenerator) {
        super()
        this.id = nanoid(8)
        this.ingredientType = ingredientType
        this.state = generator
        this.x = x
        this.y = y
        this.regenerate();
    }

    regenerate() {
        let ingredient: Ingredient = this.state.createNewIngredient(this.x, this.y, this.ingredientType, this);
        logger.info(`${this.printableId} generated ingredient ${ingredient.toString()})`)
        this.currentIngredient = ingredient
        return this.currentIngredient
    }

    bye() {
        this.regenerate()
    }
}
